import React from 'react';
import {WithTranslationProps} from 'react-i18next';
import {get} from 'lodash';

import Text from '/component/base/Text';
import {Reports} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';
import {generateComponentCallback} from '/util/component.util';
import testProperties from '/util/testing/testProperties';

interface ClientJourneyTaskProps extends WithTranslationProps {
  item: {
    nextTask: string;
  } | null;
}

export const ClientJourneyTask: React.FC<ClientJourneyTaskProps> = ({
  tt = withTranslation.ttDefaultProp,
  item = null,
}) => {
  const nextTask = get(item, 'nextTask', {});
  return tt(
    'nextTask',
    generateComponentCallback({
      component: (
        <Text
          {...testProperties(Reports.reportNextTask)}
          allowFontScaling
          maxFontSizeMultiplier={2}>
          {nextTask}
        </Text>
      ),
    }),
  );
};

export default withTranslation('report.record.nextTask')(ClientJourneyTask);
